module.exports = __webpack_public_path__ + "img/icon_mail_send_w.c191d7c0.svg";